import styled, { css } from "styled-components";

export const NavControls = styled.div<{ thirdLevel: boolean }>(({ theme, thirdLevel }) => {
  return css`
    margin-bottom: ${thirdLevel ? '1.25rem' : '1rem'};
  `;
});